import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Login from '@/components/Login'
import EditQuizzes from '@/router/EditQuizzes'
import Home from '@/router/Home'
import Quiz from '@/router/Quiz'

import Meta from 'vue-meta'

Vue.use(Router)
Vue.use(Meta)

export default new Router({
	mode: 'history',
  routes: [
    {
      path: '/asdf',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    // {
    //   path: '/quiz/:key',
    //   name: 'Quiz',
    //   component: Quiz
    // },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/user/quizzes',
      name: 'Your Quizzes',
      component: EditQuizzes
    },
    // {
    //   path: '/:key',
    //   name: 'Quiz',
    //   component: Quiz
    // }
    {
      path: '/:key(-[a-zA-Z0-9-_]{19})',
      name: 'QuizByKey',
      component: Quiz
    },
    {
      path: '/:name',
      name: 'QuizByName',
      component: Quiz,
      title: 'Penis'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js